import { tokens } from '@kdk/shared/theme';
import { IconButton, SvgIcon, Tooltip } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';

/** 月(ライトのときに表示 = 押すとダークへ)。Feather Icons(MIT)の形。 */
const MoonIcon = () => (
  <SvgIcon fontSize="small" fill="none" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    />
  </SvgIcon>
);

/** 太陽(ダークのときに表示 = 押すとライトへ)。 */
const SunIcon = () => (
  <SvgIcon fontSize="small" fill="none" stroke="currentColor" strokeWidth={2}>
    <circle cx="12" cy="12" r="4" />
    <path
      strokeLinecap="round"
      d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
    />
  </SvgIcon>
);

/** サイドバーのテーマ切替ボタン。選択はブラウザに保存され、既定はライト。 */
export const ThemeModeToggle = () => {
  // colorScheme は実際に適用されている配色。保存値が想定外でも、表示とボタンの意味が食い違わない
  const { colorScheme, setMode } = useColorScheme();
  const isDark = colorScheme === 'dark';
  const label = isDark ? 'ライトテーマに切り替え' : 'ダークテーマに切り替え';
  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        onClick={() => {
          setMode(isDark ? 'light' : 'dark');
        }}
        sx={{
          flex: 'none',
          color: tokens.sidebarMu,
          '&:hover': { bgcolor: tokens.sidebarHover, color: tokens.sidebarTx },
        }}
      >
        {isDark ? <SunIcon /> : <MoonIcon />}
      </IconButton>
    </Tooltip>
  );
};
